import styled from 'styled-components';
import { blockQuotes, pullQuotes, longQuotes } from 'styles/quotes';
import { headers } from 'styles/headers';
import { images } from 'styles/images';
import { breakpoint } from 'styles/globals';
import { paragraphs } from 'styles/paragraphs';
import { videos } from 'styles/videos';
import Heading from 'styles/typography/Heading';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const ContentContainer = styled.div`
  margin-top: 32px;
  padding: 0 16px;

  @media (${breakpoint.mmMin}) {
    margin-top: 92px;
    padding: 0 24px;
  }
  @media (${breakpoint.mdMin}) {
    margin-top: 56px;
    padding: 0;
  }
  @media (${breakpoint.lgMin}) {
    margin-top: 40px;
  }

  @media (${breakpoint.mdMin}) {
    margin: 32px auto 0px;
  }

  @media (${breakpoint.xlMin}) {
    width: 100%;
  }

  @media (${breakpoint.xxlMin}) {
    margin: 48px 0px 0px auto;
    width: calc(((100% / 12) * 10) - 8px);
  }
`;

export const ContentAndSidebarContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (${breakpoint.xlMin}) {
    flex-direction: row;
  }
`;

export const ComplexityWrapper = styled.div`
  margin-top: 40px;

  @media (${breakpoint.smMin}) {
    margin-top: 32px;
  }
  @media (${breakpoint.lgMin}) {
    margin-top: 64px;
    padding: 0;
  }
  @media (${breakpoint.xxlMin}) {
    margin-top: 56px;
  } 
`;

export const TitleWrapper = styled(Heading)`
  margin: 24px 0px 40px 0px;

  @media (${breakpoint.mmMin}) {
    margin-top: 16px;
    font-size: 3.75rem;
  } 
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ShareWrapper = styled.div`
  margin-left: 24px;
  display: flex;
  height: 76px;

  @media (${breakpoint.mmMax}) {
    margin-top: 20px;
  }

  @media (${breakpoint.mmMin}) {
    margin-left: 20px;
    height: 130px;
  } 
`;

export const ContentWrapper = styled.div<{ theme: Theme }>`
  ${paragraphs};
  ${headers};
  ${images};
  ${blockQuotes};
  ${pullQuotes};
  ${longQuotes};
  ${videos};

  ${getBodyStyle('georgia', { default: 'medium' })};
  width: fit-content;
  max-width: 100%;

  a {
    color: ${getColor('textLink')};
    text-decoration: none;

    &:hover {
      color: ${getColor('textSecondary')};
    }
  }

  div[class="rawHtml-content"] {
    > p:first-of-type {
      margin-top: 0px;
    }
  }

  .cc-term-image {
    height: auto;
  }

  a {
    &:hover {
      text-decoration: underline;
      color: ${getColor('textLink')};

    }
    &:active {
      color: ${getColor('neutralBlack')};
      text-decoration: none;
    }
  }
`;

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 48px;
  margin-top: 56px;

  & > div:nth-child(2) {
    flex: 1;
  }

  @media (${breakpoint.xlMin}) {
    padding-right: 0px;
    padding-left: 0px;
  }

  @media (${breakpoint.xlMax}) {
    & > div {
      margin-right: auto;
    }
  }
`;
